<template>

  <ankh-list>
    <template #btn-group>
      <el-button size="small" type="primary" @click="handleShowFormDialog()">新增</el-button>
      <!--   todo 曲线导出未做   -->
      <el-button size="small" type="primary" @click="handleExport">导出</el-button>
      <el-button size="small" type="danger" @click="handleBatchDelete">批量删除</el-button>
    </template>

    <template #search-form>
      <el-form-item label="模式">
        <el-input placeholder="模式" v-model="searchForm.model"/>
      </el-form-item>
      <el-form-item label="协议代码">
        <el-input placeholder="协议代码" v-model="searchForm.protocolCode"/>
      </el-form-item>
      <el-form-item label="创建日期">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">查询</el-button>
        <el-button @click="$refs.list.reset()">重置</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list ref="list"
                  :search-params="searchForm"
                  @query="loadList"
                  @selection-change="selection = $event"
                  :data="tableData">
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column label="模式" prop="model"/>
        <el-table-column label="协议代码">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建日期">
          <template v-slot="{row}">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"/>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleShowFormDialog(row)">编辑</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <hardware-form
          :rules="rules"
          :is-edit="isEdit"
          :data="currentRow"
          @confirm="handleAddOrEditSubmit"
          :visible.sync="showDialog"
          :form-items="formConfig"/>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import HardwareForm from "@/components/hardware/HardwareForm";
import {exeCommandCopyText} from "@/utils/common";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

// 表单校验
const formRules = {
  model: [
    {required: true, message: '请输入模式', trigger: 'blur'},
  ],
  protocolCode: {required: true, message: '请输入协议代码', trigger: 'change'}
}

export default {
  name: "CurveList",
  components: {AnkhList, HardwareForm, DateTimeRangePicker, TableList},
  data() {
    return {
      tableData: [],
      selection: [],
      searchForm: {},
      formConfig: [
        {label: "模式", prop: "model", type: "text"},
        {label: "协议代码", prop: "protocolCode", type: "text"},
        {label: "备注", prop: "remark", type: "textarea", rows: 5}
      ],
      rules: Object.freeze(formRules),
      isEdit: false,
      currentRow: {},
      showDialog: false,
    }
  },
  methods: {
    // 复制
    handleCopy(row) {
      const flag = exeCommandCopyText(row.protocolCode)
      this.$message({
        type: flag ? 'success' : 'error',
        message: flag ? '复制成功' : '复制失败'
      })
    },

    // 新增\编辑
    async handleAddOrEditSubmit(data) {
      try {
        const action = this.$api.graphModel[this.isEdit ? 'update' : 'add'];
        if (this.isEdit) {
          data = Object.assign(this.currentRow, data);
          delete data.createTime;
          delete data.updateTime;
        }
        await request(action, data);
        this.$message.success("操作成功");
        this.showDialog = false;
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    handleShowFormDialog(row) {
      if (row) {
        this.currentRow = {...row};
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.graphModel.delete, {code: row.code});
        this.$message.success("操作成功")
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if (!codes.length) {
          this.$message.warning("请选择要删除的项");
          return;
        }
        await requestByTip(
            this.$api.graphModel.batchDelete,
            codes,
            {isJson: true},
            {message: "您现在正在进行批量删除操作, 是否继续?"}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.graphModel.list, params);
        this.tableData = res.graphModels;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    },
    async handleExport() {
      const codes = this.selection.map(item => item.code);
      await exportExcel(codes, this.$api.common.exportGraphModel);
    }
  }
}
</script>

<style scoped>

</style>
